import Config from '../../config';
import Utils from '../../utils/util';
import { open } from './open';
import { close } from './close';

function updateSync(): void {
    let isTrans: boolean = Config.get({
        moduleName: 'freezer',
        key: 'cabinetTransLayout'
    });

    isTrans && open();
}

const updateAsync: (...args: any[]) => void = Utils.debounce(updateSync, 10);

export default {
    updateAsync,
    open,
    close
};
